<template>
  <div style="width:100%" :class="{'multipleMovile' : windowSize<992}">  
      <table class="table table--get table-hover border box-effect linear" v-if="dataForm[namePath][tableTabla] instanceof Array && dataForm[namePath][tableTabla]">
        <thead>
          <tr>
            <th :style="items.thead.style" v-for="(items,index) in tableItems" :key="'theadForm'+index">
              {{items.thead.th}}
            </th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items,index) in dataForm[namePath][tableTabla]" :key="'tbody'+tableTabla+'Form'+index">
            <td class="date-tableform" style="padding: 8px 4px;"  v-for="(items2,index2) in tableItems" :key="'tbodyForm'+index2">
              <b-row>
                <b-col style="padding:0" :sm="(items2.tbody.col) ? items2.tbody.col[index3] : 12/items2.tbody.td.length" :md="(items2.tbody.col) ? items2.tbody.col[index3] : 12/items2.tbody.td.length"
                    v-for="(items3,index3) in items2.tbody.td" :key="'tdForm'+index3">
                    {{typeof items3==='string'}}
                  <sw-inputstableform
                    v-if="typeof items3==='string'"
                    :inputTabla="tableTabla"
                    :inputCampo="items3"
                    :index="index"
                    >
                  </sw-inputstableform>
                  <div v-else>
                    {{items3.tabla}} -
                    {{items3.campo}}
                  </div> 
                </b-col>
              </b-row>             
            </td>
            <td  class="text-center" style="padding: 8px 4px;" >
              <b-icon @click="spliceDataForm({state: tableTabla, index: index})"  class="option-btn" icon="trash-fill" scale="1.3" variant="danger"></b-icon>                 
            </td>
          </tr>         
        </tbody>
      </table>
      <b-button size="sm" variant="outline-info" @click="pushDataForm({ state: tableTabla, data: camposAgregados })">Agregar Campo</b-button>
  </div>
</template>
<script>
import SwInputstableform from '@/components/forms/inputsTableform.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
function cleanParameter(value)
  {
    if(value==null)
    {
      return '';
    }
    return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
export default 
{
  name: 'swTableget',
  components: { SwInputstableform },
  data () {
    return {
      currentSearch:'',
      currentSort:'id',
      currentSortDir: '',
      camposAgregados: {}
    }
  },
  props: {
    inits:  {
      type: Array,
      default: function()
      {
        return [ ]
      }
    },
    tableCampos: {
      type: Array,
      default: function()
      {
        return [ ]
      }
    },
    tableItems: {
      type: Array,
      default: function()
      {
        return [ ]
      }
    },
    tableTabla: {
      type: String,
      default: ''
    }
  },
  async created()  {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    for (let i = 0; i < this.tableCampos.length; i++) {
        if(typeof this.tableCampos[i]==='string')
        {
          this.camposAgregados[this.tableCampos[i]]=this.datadb[this.tableTabla][this.tableCampos[i]].datatype.predeterminate
        }
    }
    if(this.inits.length>0)
    {
      await this.updateDataForm({ state: this.tableTabla, data: this.inits  })
    }
    else 
    {
      await this.updateDataForm({ state: this.tableTabla, data: []  })
      this.dataForm[this.namePath][this.tableTabla]=[]      
    }
  },
  computed: {    
  },
  methods: {   
      async handleResize(){
        await this.updateGlobal({state: 'windowSize',data: window.innerWidth})
      }, 
    sort(sort,td,index){   
      for(var i=0;i<this.tableItems.length;i++)
      {
        if(index!==i)
        {
          if(this.tableItems[i].thead.sort!==undefined)
          {
            this.tableItems[i].thead.sort=null
          }          
        }        
      }
      this.currentSort=td  
      this.currentSortDir = 'desc'
      if(sort===null || sort===false)
      {
        this.currentSortDir = 'asc'
        return true
      }
      return !sort
    },
    sortedTable(){
       let vm = this;  

        let dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data).filter(list => {

        return this.tableSearch.find( items => {
            return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
          })         
        })     
        return dataFilter.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if(a[this.currentSort] > b[this.currentSort]) return  1 * modifier
          return 0
        });      
    },  
  }
}
</script>
<style>
.sw-search{
  margin-bottom: 0 !important
}
.sw-search .input-group-text {
    border-radius: 0.25rem 0 0 0 !important;
}
.sw-search .search-radius{
    border-radius:  0 0.25rem 0 0 !important;
}
.table--get thead tr{
  border-left: 1px solid #ced4da;
  border-right: 1px solid #ced4da;
}
.table--get tr th{
    color: #495057;
    background-color: #e9ecef;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border-top: none;
}
.sw-sort{
  background-image: url('/images/sort.svg');
  width: 11px;
  height: 18px;
  float: right;
  background-size: cover;
  margin-top: 3px;
  cursor:pointer;
}
.sw-sortdown{
  background-image: url('/images/sortdown.svg');
}
.sw-sortup{
  background-image: url('/images/sortup.svg');
}
.date-tableform .input-date {
  width: 146px !important;
}
.multipleMovile{
  zoom: 0.7;
  overflow-x:scroll;
}
</style>